import React, {useState} from 'react'
import styles from '../LeadManagementStyles/LeadManagementStyle.module.css'
import {FormikValues, useFormik} from 'formik'
import * as Yup from 'yup'
import {leadPropertyStatus} from '../LeadManagementAPI'
import {SaveFeedbackDataType} from '../LeadManagementDataTypes'

const SaveFeedback = ({
  setSaveFeedback,
  setScheduleVisit,
  leads_property_uuid,
  getLeadList,
  returnStatusColor,
  customer_feedback,
  leads_property_status,
  setSuccessMsg,
  setError,
  setAcceptedProperty,
}: any) => {
  // SaveFeedbackDataType
  const [selectedStatus, setSelectedStatus] = useState<string>(leads_property_status)
  const [saveFeedbackBtnLoading, setSaveFeedbackBtnLoading] = useState<boolean>(false)

  // validation schema for save feedback
  const validationSchema = Yup.object().shape({
    leads_property_status: Yup.string().required('Status is required'),
    customer_feedback: Yup.string().optional(),
  })

  // function to save feedback
  const handleSaveFeedback = async (values: FormikValues) => {
    setSaveFeedbackBtnLoading(true)
    try {
      const {data: response} = await leadPropertyStatus(
        leads_property_uuid,
        parseInt(values.leads_property_status, 10),
        values.customer_feedback
      )
      if (response.code === '200') {
        setAcceptedProperty([])
        getLeadList()
        setSaveFeedback(null)
        setSuccessMsg(`Success: Feedback Saved Successfully!`)
      } else {
        setError(`Error: ${response.msg_details}`)
      }
    } catch (error: any) {
      setError(`Error: ${error}`)
    } finally {
      setSaveFeedbackBtnLoading(false)
    }
  }

  // formik object for save feedback
  const formik = useFormik({
    initialValues: {
      customer_feedback: customer_feedback ? customer_feedback : '',
      leads_property_status,
    },
    validationSchema,
    onSubmit: (values) => handleSaveFeedback(values),
  })

  // function onchange status
  const handleStatusChange = (status: string) => {
    setSelectedStatus(status)
    formik.setFieldValue('leads_property_status', status, true)
  }
  return (
    <tr className='w-100'>
      <td colSpan={5}>
        <div className='d-flex justify-content-between'>
          {/* Begin: heading */}
          <h4>Save Feedback</h4>
          {/* End: heading */}
          {/* Begin: Close button */}
          <div
            className='btn btn-sm btn-icon btn-active-color-primary px-5'
            onClick={() => {
              setSaveFeedback(null)
              setScheduleVisit(null)
            }}
          >
            <i className='bi bi-x-lg'></i>
          </div>
          {/* End: Close button */}
        </div>
        {/* Begin: Form */}
        <form onSubmit={formik.handleSubmit}>
          <div className='row w-100'>
            {/* Begin: form group Feedback */}
            <div className={`fv-row col-12 col-lg-7`}>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span>Feedback</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Enter Feedback'
                ></i>
              </label>
              <textarea
                className='form-control form-control-lg form-control-solid'
                placeholder='Enter Feedback'
                {...formik.getFieldProps('customer_feedback')}
                name='customer_feedback'
              />
              {/* <div className='h-20px'> */}
                {formik.touched.customer_feedback && formik.errors.customer_feedback && (
                  <div className='fv-help-block color-red'>
                    {formik.errors.customer_feedback.toString()}
                  </div>
                )}
              {/* </div> */}
            </div>
            {/* End: form group Feedback */}
            {/* Begin: form group  Status */}
            <div className={`fv-row col-12 col-lg-3`}>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Status</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Choose status'
                ></i>
              </label>
              <select
                className={`form-select py-2 px-4 ${
                  selectedStatus && returnStatusColor(parseInt(selectedStatus, 10))
                }`}
                {...formik.getFieldProps('leads_property_status')}
                name='leads_property_status'
                placeholder='Select status'
                onChange={(e) => handleStatusChange(e.target.value)}
              >
                <option className='bg-color-gray text-dark' value=''>
                  Select status
                </option>
                <option value='0' className='bg-color-gray text-dark' disabled>
                  Added
                </option>
                <option value='1' className='bg-color-white text-dark'>
                  Accepted
                </option>
                <option value='2' className='bg-color-gray text-dark' disabled>
                  Scheduled
                </option>
                <option value='3' className='bg-color-white text-dark'>
                  Visited
                </option>
                <option value='4' className='bg-color-white text-dark'>
                  Rejected
                </option>
                {/* <option value='5' className='bg-color-white text-dark'>
                  Delete
                </option> */}
              </select>
              {/* <div className='h-20px'> */}
                {formik.touched.leads_property_status && formik.errors.leads_property_status && (
                  <div className='fv-help-block color-red'>
                    {formik.errors.leads_property_status.toString()}
                  </div>
                )}
              {/* </div> */}
            </div>
            {/* End: form group  Status */}
            <div className={`fv-row mt-4 col-12 col-lg-2`}>
              {/* Begin:: submit button */}
              <button
                type='submit'
                className='btn btn-lg btn-primary mt-5 w-100'
                // data-kt-stepper-action='submit'
                disabled={saveFeedbackBtnLoading}
              >
                {saveFeedbackBtnLoading ? (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Processing...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                ) : (
                  'Submit Feedback'
                )}
              </button>
              {/* Begin:: submit button */}
            </div>
          </div>
        </form>
        {/* End: Form */}
      </td>
    </tr>
  )
}

export default SaveFeedback
